import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';


function ClassRegister() {
  const [assigments, setAssigments] = useState([]);
  const [assigmentInfo, setInfo] = useState({});
  const [info, showInfo] = useState(false);
  const [registerClass, setRegister] = useState({
    StudentId: '', ProfessorId: '', date: '', duration: '', lesson_type: '', lecture: '', replacement: '',
  });
  const [professors, setProfessors] = useState([]);
  const [error, setError] = useState({ isError: false, message: '' });
  const [user, setUser] = useState([]);

  const assignationsPath = '/assignations/get';
  const professorsPath = '/professors/get';
  const lessonTypePath = '/administrator/lessontypes/get';

  useEffect(() => {
    fetch(assignationsPath)
      .then((r) => r.json())
      .then((data) => { setAssigments(data); })
      .catch(console.log);
    fetch(professorsPath)
      .then((r) => r.json())
      .then((data) => setProfessors(data))
      .catch(console.log);
    fetch(lessonTypePath)
      .then((r) => r.json())
      .then((data) => setUser(data))
      .catch(console.log);
  }, []);

  function onChange(event) {
    event.persist();
    setError({ isError: false, message: '' });
    setRegister((prev) => ({ ...prev, [event.target.name]: event.target.value }));
    if (event.target.name === 'ProfessorId') {
      setRegister((prev) => ({
        ...prev,
        replacement: event.target.value == assigmentInfo.Professor.id ? 'No' : 'Si',
      }));
    }
  }

  function sendInfo() {
    fetch('./lessons/new', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(registerClass),
    })
      .then((response) => {
        if (response.status === 200) {
          alert('Clase registrada con éxito');
          setRegister({ StudentId: '', ProfessorId: '', date: '', duration: '', lesson_type: '', lecture: '', replacement: '' });
          showInfo(false);
        }
      })
      .catch(() => alert('Hubo un problema al publicar, por favor, intenta denuevo'));
  }

  async function handleSubmit() {
    let emptyAttribute = false;
    if (Object.values(registerClass).indexOf('') > -1) {
      setError({ isError: true, message: 'Debes rellenar todos los campos' });
      emptyAttribute = true;
    }
    if (!error.isError && !emptyAttribute) sendInfo();
  }

  const sortingArray = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes'];
  const sortedAssigments = [...assigments].sort((a, b) => sortingArray.indexOf(a.day) - sortingArray.indexOf(b.day));

  return (
    <div className="cr-wrap">

        {/* ── LEFT: assignations table ── */}
        <div className="cr-panel">
          <div className="cr-panel-header">
            <div className="cr-panel-title">
              <div className="cr-panel-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
              </div>
              <div>
                <h2>Asignaciones</h2>
                <p>Presiona una fila para registrar clase</p>
              </div>
            </div>
            <span className="cr-count-badge">{assigments.length}</span>
          </div>

          <div style={{ overflowX: 'auto' }}>
            <table className="cr-table">
              <thead>
                <tr>
                  <th>Día</th>
                  <th>Hora</th>
                  <th>Profesor</th>
                  <th>Alumno/a</th>
                  <th>Apoderado</th>
                </tr>
              </thead>
              <tbody>
                {sortedAssigments.map((a) => (
                  <tr
                    key={a.id}
                    className={info && assigmentInfo.id === a.id ? 'cr-selected' : ''}
                    onClick={() => {
                      showInfo(false);
                      setInfo(a);
                      showInfo(true);
                      setRegister((prev) => ({
                        ...prev,
                        StudentId: a.Student.id,
                        ProfessorId: a.Professor.id,
                        duration: 1,
                        lesson_type: a.lesson_type,
                        replacement: 'No',
                      }));
                    }}
                  >
                    <td><span className="cr-day-badge">{a.day}</span></td>
                    <td>{a.hour}</td>
                    <td>{a.Professor.name}</td>
                    <td>{a.Student.name}</td>
                    <td>{a.Student.mother}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── RIGHT: register form ── */}
        <div className="cr-form-card">
          {!info ? (
            <div className="cr-empty">
              <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="rgb(180,130,70)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.35 }}><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
              <p className="cr-empty-title">Sin asignación seleccionada</p>
              <p className="cr-empty-sub">Haz clic en una fila para registrar una clase</p>
            </div>
          ) : (
            <>
              <div className="cr-form-header">
                <h3>Registrar clase</h3>
                <p>Completa los datos de la clase</p>
              </div>
              <div className="cr-form-body">

                <div className="cr-student-info">
                  <div className="cr-student-name">{assigmentInfo.Student.name}</div>
                  <div className="cr-student-sub">Apoderado/a: {assigmentInfo.Student.mother}</div>
                </div>

                <div className="cr-group">
                  <label className="cr-label">Profesor</label>
                  <select className="cr-control" id="ProfessorId" name="ProfessorId" onChange={onChange} value={registerClass.ProfessorId}>
                    <option value={assigmentInfo.Professor.id}>{assigmentInfo.Professor.name}</option>
                    {professors.map((p) => (
                      <option value={p.id} key={p.id}>{p.name}</option>
                    ))}
                  </select>
                </div>

                <div className="cr-group">
                  <label className="cr-label">Fecha</label>
                  <input className="cr-control" type="text" id="date" name="date" placeholder="Ej: Miercoles 21" value={registerClass.date} onChange={onChange} required />
                </div>

                <div className="cr-group">
                  <label className="cr-label">Materia</label>
                  <input className="cr-control" type="text" id="lecture" name="lecture" placeholder="Materia" value={registerClass.lecture} onChange={onChange} maxLength="25" required />
                  <div className="cr-char-count">{registerClass.lecture.length}/25</div>
                </div>

                <div className="cr-group">
                  <label className="cr-label">Duración</label>
                  <div className="cr-radio-group">
                    {[{ val: '1.5', label: '1,5 hr' }, { val: '1', label: '1 hr' }, { val: '0.5', label: '0,5 hr' }].map(({ val, label }) => (
                      <div className="cr-radio-btn" key={val}>
                        <input type="radio" id={`dur-${val}`} name="duration" value={val} onChange={onChange} checked={registerClass.duration == val} />
                        <label htmlFor={`dur-${val}`}>{label}</label>
                      </div>
                    ))}
                  </div>
                </div>

                {user.LessonAssigments && (
                  <div className="cr-group">
                    <label className="cr-label">Tipo de clase</label>
                    <div className="cr-type-group">
                      {user.LessonAssigments.map((la) => (
                        <label className="cr-type-option" key={la.LessonType.id}>
                          <input type="radio" name="lesson_type" value={la.LessonType.id.toString()} onChange={onChange} checked={registerClass.lesson_type === la.LessonType.id.toString()} />
                          <span className="cr-type-name">{la.LessonType.name}</span>
                          <span className="cr-type-price">${la.LessonType.charge}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                )}

                {error.isError && (
                  <div className="cr-error">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                    {error.message}
                  </div>
                )}

                <button className="cr-submit" type="button" onClick={handleSubmit}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  Registrar clase
                </button>

              </div>
            </>
          )}
        </div>

      </div>
  );
}

export default hot(module)(ClassRegister);
